import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 25px',
    backgroundColor: theme.palette.whitePepper.main,
  },

  videoWrapper: {
    margin: '0 auto',
    maxWidth: '1100px',
    height: '300px',
    backgroundColor: 'whitePepper.main',

    [theme.breakpoints.up('md')]: {
      height: '600px',
    },
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '10px',
  },

  imgWrapper: {
    flexShrink: 0,
    position: 'relative',
    maxWidth: '1100px',
    width: '100%',
    //height: '300px',
    [theme.breakpoints.up('md')]: {
      //height: '600px',
    },
  },
});
